import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MainService } from 'src/app/services/main.service';
import { EnableDebtCollectionComponent } from '../enable-debt-collection/enable-debt-collection.component';

@Component({
  selector: 'app-collecting-modal',
  templateUrl: './collecting-modal.component.html',
  styleUrl: './collecting-modal.component.scss',
})
export class CollectingModalComponent implements OnInit {
  extra_data = {type:1};
  floating_modal: boolean = false;
  doctor_debt_type : any;
  constructor(private bsModalRef: BsModalRef,
    private _router: Router,
    private main: MainService,
    private modalService: BsModalService

  ) {}
  ngOnInit(): void {
    this.doctor_debt_type = this.main.doctor_profile.doctor_debt_type ? this.main.doctor_profile.doctor_debt_type : '';
    // if(this.extra_data?.type == "sidebar"){
    //   this.floating_modal = true;
    // }
  }
  closeModal() {
    console.log('Modal closed');
    this.bsModalRef.hide();
  }

  selectDebt(type: 'consumer' | 'commercial') {
    if(type == 'consumer' && this.doctor_debt_type != 2){
      this.bsModalRef?.hide();  
      this._router.navigate(['/app/debt-recuvery/single-debt-recuvery'], { queryParamsHandling: 'merge' });
    }
    else if(type == 'commercial' && this.doctor_debt_type != 1){
      this.bsModalRef?.hide();
      this._router.navigate(['/app/debt-recuvery/single-debt-recuvery-comercial'], { queryParamsHandling: 'merge' });
    }
  }
  showAddDebtCollectionModal(type : any){
      this.bsModalRef?.hide(); 
        this.bsModalRef = this.modalService.show(EnableDebtCollectionComponent, {
          initialState: {
            extra_data: {
              type: type,
            }
          }, 
          backdrop:true,
          class: 'modal-dialog-centered'
        });
    }
}
